import $ from "jquery";
import bdapi from "@bd-core/bd-api";

export const LeaderboardPage = () => {
  const isLeaderboardPage = $(".leaderboard-page");
  if (!isLeaderboardPage.length) return false;

  const $elms = {
    btnReplay: $("#replayButton"),
    btnRating: $("#rateButton"),
    btnClosePopUp: $(".closePopup"),
    btnSubmitRating: $("#submitRating"),
    popUpRating: $(".ratingPopup"),
    ratingSlider: $(".js-rating-slider"),
  };

  function onReplay() {
    $elms.btnReplay.attr("disabled", "disabled");

    bdapi
      .post("member/reset-active-game-progress", {})
      .then(() => {
        window.location.href = "/";
      })
      .catch(() => {
        $elms.btnReplay.removeAttr("disabled");
      });
  }

  function onSubmitRating() {
    $elms.btnSubmitRating.attr("disabled", "disabled");
    var ratingValue;

    const val = $elms.ratingSlider.val();
    const max = $elms.ratingSlider.prop("max");
    ratingValue = "slider," + val + "/" + max;

    bdapi
      .post("game/submit-rating", { rating_value: ratingValue })
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        hideRatingPopUp();
        $elms.btnSubmitRating.removeAttr("disabled");
      });
  }

  function onSlidingRate() {
    const $bubble = $(".inputSlider__thumb .value");
    const $thumb = $(".inputSlider__thumb");
    const val = parseInt($elms.ratingSlider.val().toString());
    const minValue = 1;

    if (val < minValue) {
      $elms.ratingSlider.val(minValue);
      return;
    }

    const min = $elms.ratingSlider.prop("min");
    const max = $elms.ratingSlider.prop("max");
    const newVal = Number(((val - min) * 100) / (max - min));
    // @ts-ignore
    $bubble.innerHTML = val;

    $bubble.html(val.toString());
    $thumb.css("left", newVal + "%");
  }

  function showRatingPopUp() {
    $elms.popUpRating.addClass("is-opened");
  }

  function hideRatingPopUp() {
    $elms.popUpRating.removeClass("is-opened");
  }

  $elms.btnReplay.on("click", onReplay);
  $elms.btnRating.on("click", showRatingPopUp);
  $elms.btnClosePopUp.on("click", hideRatingPopUp);
  $elms.btnSubmitRating.on("click", onSubmitRating);
  $elms.ratingSlider.on("input", onSlidingRate);
};
